var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBathtubHydro(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 19C14 19.5523 13.5523 20 13 20C12.4477 20 12 19.5523 12 19C12 18.4477 12.4477 18 13 18C13.5523 18 14 18.4477 14 19Z",
    fill: "#00112B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20C16.5523 20 17 19.5523 17 19C17 18.4477 16.5523 18 16 18C15.4477 18 15 18.4477 15 19C15 19.5523 15.4477 20 16 20Z",
    fill: "#00112B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 19C20 19.5523 19.5523 20 19 20C18.4477 20 18 19.5523 18 19C18 18.4477 18.4477 18 19 18C19.5523 18 20 18.4477 20 19Z",
    fill: "#00112B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 9.5C12.1022 9.5 11.7206 9.65804 11.4393 9.93934C11.158 10.2206 11 10.6022 11 11V15H22C22.5523 15 23 15.4477 23 16V19C23 20.6569 21.6569 22 20 22C20 22.5523 19.5523 23 19 23C18.4477 23 18 22.5523 18 22H14C14 22.5523 13.5523 23 13 23C12.4477 23 12 22.5523 12 22C10.3431 22 9 20.6569 9 19V16C9 15.4477 9.44772 15 10 15V11C10 10.337 10.2634 9.70107 10.7322 9.23223C11.2011 8.76339 11.837 8.5 12.5 8.5C13.163 8.5 13.7989 8.76339 14.2678 9.23223C14.7366 9.70107 15 10.337 15 11C15.5523 11 16 11.4477 16 12C16 12.5523 15.5523 13 15 13H14C13.4477 13 13 12.5523 13 12C13 11.4477 13.4477 11 14 11C14 10.6022 13.842 10.2206 13.5607 9.93934C13.2794 9.65804 12.8978 9.5 12.5 9.5ZM10 19V17H22V19C22 20.1046 21.1046 21 20 21H12C10.8954 21 10 20.1046 10 19Z",
    fill: "#00112B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathtubHydro);
export default __webpack_public_path__ + "static/media/bathtub_hydro.fe2dc20950660da65a591a901d5630f4.svg";
export { ForwardRef as ReactComponent };